import Tool, { type ToolArgs } from '../../../tools/Tool';
import { inListOfType } from '../utils';
import ListWrapUtils from '../ListWrapUtils';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import definitionListSvg from '../../../assets/icons/definitionList.svg';

// Convert selection to/from a definition list.
class ToolDefinitionList extends Tool {
  static toolName = 'Description list';

  static action({ editor }: ToolArgs): void {
    if (this.isActive({ editor })) {
      ListWrapUtils.unwrapList(editor);
    } else {
      ListWrapUtils.wrapInList(editor, { type: 'dl_list' });
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    return inListOfType(editor, 'dl_list');
  }

  static isEnabled({ controller }: ToolArgs): boolean {
    const tableSelection = controller?.state.pluginState.tableSelection;
    if (!tableSelection) return true;

    return !tableSelection.multipleCellsSelected;
  }

  static renderMenuIcon({ editor }: ToolArgs): JSX.Element {
    return svgToIcon(definitionListSvg);
  }
}

export default ToolDefinitionList;
